module.exports = __webpack_public_path__ + "img/type4_check_2.335acc80.png";